var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text)?_c('p',{ref:"message",class:['action-result-message', 'action-result-message--' + _vm.type],attrs:{"role":_vm.type === 'danger' ? 'alert' : 'status'}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }